<template>
    <div v-if="article">
        <AppHeader closeable="true" title="Article"></AppHeader>

        <section class="container container-lg mb--100">
            <h1 class="text--center mb--0">{{ article.title }}</h1>

            <p v-html="article.lead"></p>
            <p v-html="article.description"></p>
        </section>
        <navigation></navigation>
    </div>
</template>

<script>
    import AppHeader from "./partial/AppHeader";
    import Navigation from "./partial/Navigation";
    import api from "../api/article";

    export default {
        name: "Article",
        components: {AppHeader, Navigation},
        props: {
            slug: {
                required: true
            }
        },
        data: function () {
            return {
                article: null
            }
        },
        methods: {
            async search() {
                try {
                    let response = await api.show(this.slug);

                    this.article = response.data;
                } catch (error) {
                    if (error.response.status === 404) {
                        this.$router.push('/404')
                    }
                }
            }
        },
        created() {
            this.search();
        }
    }
</script>